import { doRequestAxios } from 'srcReact/helpers/apiHelper'
import authHeader from 'srcReact/helpers/auth-header'

export const dashboardService = {
  getDashboardData
}

function getDashboardData(object_type, object_id) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      object_type,
      object_id
    }
  }
  return doRequestAxios(`/v2/dashboard/getdata`, requestOptions)
}
